import React from 'react';

const Edit = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 32 32"
    className="rcx-svg--directional"
    fill="currentColor"
    {...props}
  >
    <path d="M24.841 4.0706L28.0554 7.47976C28.8023 8.2719 28.7783 9.51592 28.0016 10.2788L11.1961 26.7825C10.8868 27.0862 10.4872 27.2812 10.0576 27.3382L6.56885 27.8007C5.18073 27.9847 4.03809 26.7221 4.35934 25.3592L5.27696 21.4663C5.3607 21.111 5.54005 20.7854 5.79559 20.5248L21.9578 4.04235C22.7527 3.23172 24.0622 3.24455 24.841 4.0706ZM20.1534 8.73912L23.4045 11.9902L26.6002 8.85179L23.3859 5.44263L20.1534 8.73912ZM18.7531 10.1672L7.22361 21.9251L6.306 25.818L9.79471 25.3555L21.9774 13.3916L18.7531 10.1672Z" />
  </svg>
);

export default Edit;
